var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 34,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6758 5C26.4444 5 29.5 8.09091 29.5 11.9033C29.4998 15.7156 26.4443 18.8057 22.6758 18.8057C20.9864 18.8056 19.4416 18.1832 18.25 17.1543C17.0584 18.1832 15.5137 18.8056 13.8242 18.8057C10.0557 18.8057 7.00018 15.7156 7 11.9033C7 8.09091 10.0556 5 13.8242 5C15.5134 5.00011 17.0584 5.62186 18.25 6.65039C19.4416 5.62185 20.9866 5.00011 22.6758 5Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6758 5C26.4444 5 29.5 8.09091 29.5 11.9033C29.4998 15.7156 26.4443 18.8057 22.6758 18.8057C20.9863 18.8056 19.4416 18.1832 18.25 17.1543C19.7164 15.8882 20.6474 14.0064 20.6475 11.9033C20.6475 9.79982 19.7168 7.91652 18.25 6.65039C19.4416 5.62185 20.9866 5.00011 22.6758 5Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 6.65088C19.7166 7.917 20.6475 9.79949 20.6475 11.9028C20.6475 14.0059 19.7163 15.8877 18.25 17.1538C16.7837 15.8877 15.8525 14.0059 15.8525 11.9028C15.8525 9.79951 16.7834 7.917 18.25 6.65088Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.f72479de187a3f4d563212a845d71fdd.svg";
export { ForwardRef as ReactComponent };